<div class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutGap="5px" fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-icon>settings</mat-icon><span i18n>Toggle Competence</span>
    </div>
</div>
